import React from 'react'
import { Text, SummaryExercise, Heading } from 'components/library'
import pdf from './assets/5c8a1c4bfe36da2d5e24d52d-1555063101573-H1_Veldkennis_in_de_praktijk_SLEEP.pdf'

const Intro = props => (
	<div>
		<Text><strong>In dit hoofdstuk leer je:</strong></Text>
		<ul style={{marginTop: '0'}}>
			<li>wat de verschillende borden en markeringen betekenen;</li>
			<li>wat de standaardrijroutes en meest voorkomende baankruisingen zijn;</li>
			<li>welk deel van het landingsterrein aangestuurd wordt door Apron-Noord en welk deel door Apron-Zuid.</li>
		</ul>
	</div>
)

const Summary = props => (
	<div>
		<div>
			<ul style={{marginTop: '0'}}>
				<li>welke sleepgebieden er binnen Schiphol zijn en waar de scheidingen liggen;</li>
				<li>welk deel van het landingsterrein aangestuurd wordt door Apron-Noord en welk deel door Apron-Zuid;</li>
				<li>wat de verschillende verkeerstekens betekenen;</li>
				<li>wat de standaard rijroutes en meest voorkomende baankruisingen zijn;</li>
				<li>wat je moet doen als je problemen hebt met je oriëntatie in het landingsterrein;</li>
				<li>in welke situaties je het sleepoverzicht kunt raadplegen.</li>
			</ul>
		</div>
		<div>
			<SummaryExercise link={pdf}>
				<Heading h3>Veldkennis in de praktijk</Heading>
		    <ul style={{marginTop: '0'}}>
		      <li>Ga met je instructeur het landingsterrein op en kijk of je de verschillende verkeerstekens herkent.</li>
		      <li style={{margin: '3rem 0'}}>Rijd met je instructeur vanaf rijbaan Alfa en Bravo eens naar verschillende VOP's, herken je de in- en outbound routes?</li>
		      <li>Ga met je instructeur langs de verschillende baankruisingen, weet je nog waar je ze aan kunt herkennen?</li>
					<li style={{margin: '3rem 0'}}>Vraag aan je instructeur of jullie langs de verschillende meldpunten kunnen rijden. Bedenk bij elk meldpunt of je je bij Apron-Noord of Apron-Zuid moet melden.</li>
		      <li>Rijd samen met je instructeur eens naar Schiphol-Oost, kijk eens op de sleepkaart of je herkent welke route jullie nemen.</li>
		    </ul>
			</SummaryExercise>
		</div>
  </div>
)

export { Intro, Summary }



// WEBPACK FOOTER //
// ./src/content/chapters/01/index.js